import { UnitOfMeasureTypes } from 'src/common/enumerations/unit-of-measure-type';
import { EJRecordTypes } from '../../common/enumerations/ej-record-types';
import { convertCurrency } from '../../common/helpers/currency-helper';
import { IItemLookup } from '../../common/interfaces/dtos/IItemLookup';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';
import { LineItemAddDto } from '../../items-list/business-logic/service/interfaces/line-item-add.dto';

const getUnitPrice = (itemLookup: IItemLookup, isMsu: boolean): string => {
  let baseUnit = `${itemLookup.unitsOfMeasure}`;

  if (isMsu) {
    baseUnit = `${itemLookup.regularSalesUnitPrice?.quantity} ${baseUnit}`;
  }

  return baseUnit;
};

export const convert = (
  itemLookup: IItemLookup,
  lineItem: LineItemAddDto,
): IElectronicJournalRecord => {
  const isMsu = (itemLookup.regularSalesUnitPrice?.quantity ?? 1) > 1;
  const price = convertCurrency(
    itemLookup.regularSalesUnitPrice?.price.value || itemLookup.unitPrice || 0,
    itemLookup.regularSalesUnitPrice?.price.currency,
  );
  const numericPrice = Number(
    (itemLookup.regularSalesUnitPrice?.price.value || itemLookup.unitPrice || 0).toFixed(2),
  );
  return {
    SequenceNumber: 0,
    UnitPrice: `${price} / ${getUnitPrice(itemLookup, isMsu)}`,
    IsMsu: isMsu,
    Name: itemLookup.description || '',
    Quantity: lineItem.quantity.value,
    ItemId: itemLookup.itemId,
    UnitOfMeasureCode: itemLookup.unitsOfMeasure || UnitOfMeasureTypes.Each,
    Price: price,
    Voided: false,
    Type: EJRecordTypes.Product,
    Selected: true,
    EligibilityInfo: [],
    NumericUnitPrice: numericPrice,
    PackQuantity: itemLookup.packQuantity,
  };
};
